module.exports = __webpack_public_path__ + "static/media/more.d01ddd9c.svg";